(() => {
  const patchExploreDrawers = (root = document) => {
    root.querySelectorAll('facet-drawer.mt-explore-series__drawer').forEach((drawer) => {
      Object.defineProperty(drawer, 'openFrom', {
        configurable: true,
        get() {
          return this.getAttribute('open-from') || 'left';
        }
      });
    });
  };

  const bindMobileFilterControls = (root = document) => {
    root.querySelectorAll('.mt-explore-series__mobile-filter[aria-controls]').forEach((button) => {
      if (button.dataset.mtExploreDrawerBound === 'true') return;

      button.dataset.mtExploreDrawerBound = 'true';
      button.addEventListener('click', (event) => {
        const drawer = document.getElementById(button.getAttribute('aria-controls'));

        if (!drawer || typeof drawer.show !== 'function') return;

        event.preventDefault();
        event.stopPropagation();

        if (drawer.hasAttribute('open')) {
          drawer.hide();
        } else {
          drawer.show();
        }
      });
    });
  };

  const preserveFacetUrlParamsOnUpdate = (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.matches('form.mt-explore-series__form[is="facet-form"]')) return;

    const sectionId = form.getAttribute('section-id');
    const section = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;

    // Facet drawers are temporarily portaled to document.body while open.
    if (!section?.querySelector('.mt-explore-series')) return;

    const url = event.detail?.url;
    if (!(url instanceof URL)) return;

    const currentUrl = new URL(window.location.href);

    ['view', 'sort_by'].forEach((name) => {
      const value = currentUrl.searchParams.get(name);
      if (value && !url.searchParams.has(name)) {
        url.searchParams.set(name, value);
      }
    });
  };

  const clearPortaledMobileFilters = (event) => {
    const clearLink = event.target.closest?.(
      'facet-drawer.mt-explore-series__drawer .mt-explore-series__clear[is="facet-link"]'
    );

    if (!clearLink) return;

    const drawer = clearLink.closest('facet-drawer.mt-explore-series__drawer');
    const form = clearLink.closest('form.mt-explore-series__form[is="facet-form"]');
    const sectionId = form?.getAttribute('section-id');

    // The theme's native facet-link expects to be inside .shopify-section.
    if (!drawer || drawer.parentElement !== document.body || !form || !sectionId) return;

    event.preventDefault();
    event.stopPropagation();

    const url = new URL(clearLink.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    const updateFilters = () => {
      form.dispatchEvent(new CustomEvent('facet:update', {
        bubbles: true,
        detail: { url }
      }));
    };

    if (drawer.hasAttribute('open')) {
      drawer.addEventListener('dialog:after-hide', updateFilters, { once: true });
      drawer.hide();
    } else {
      updateFilters();
    }
  };

  const updateMobileSort = (event) => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    const listbox = event.target.closest?.('x-listbox');
    const popover = listbox?.closest('x-popover[id^="mt-explore-sort-mobile-"]');

    if (!popover || popover.parentElement !== document.body) return;

    // Mobile popovers are portaled to document.body, which bypasses FacetSortBy's listener.
    const trigger = document.querySelector(`[aria-controls="${CSS.escape(popover.id)}"]`);
    const section = trigger?.closest('.shopify-section');
    const sortBy = trigger?.closest('facet-sort-by');

    if (!section || !sortBy) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.detail.value);
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
    url.searchParams.delete('page');

    sortBy.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url }
    }));
  };

  const initializeExploreSeries = (root = document) => {
    patchExploreDrawers(root);
    bindMobileFilterControls(root);
  };

  const onKeydown = (event) => {
    const input = event.target.closest('[data-mt-explore-search]');
    if (!input || event.key !== 'Enter') return;

    event.preventDefault();
    const query = input.value.trim();
    if (!query) return;

    const searchUrl = input.dataset.searchUrl || '/search';
    const url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    window.location.href = url.toString();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeExploreSeries, { once: true });
  } else {
    initializeExploreSeries();
  }

  if (document.documentElement.dataset.mtExploreViewUpdateBound !== 'true') {
    document.documentElement.dataset.mtExploreViewUpdateBound = 'true';
    document.addEventListener('facet:update', preserveFacetUrlParamsOnUpdate, true);
    document.addEventListener('listbox:change', updateMobileSort);
    document.addEventListener('click', clearPortaledMobileFilters, true);
  }

  document.addEventListener('shopify:section:load', (event) => initializeExploreSeries(event.target));
  document.addEventListener('keydown', onKeydown);
})();
